import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function CheckoutPix() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('pending');
  const [copied, setCopied] = useState(false);
  const intervalRef = useRef(null);

  const { paymentId, qrCode, pixCopyPaste, ticketUrl } = state || {};

  useEffect(() => {
    if (!paymentId) return;

    // Verifica o status a cada 5 segundos
    intervalRef.current = setInterval(async () => {
      try {
        const { data } = await api.get(`/checkout/pix/status/${paymentId}`);
        setStatus(data.status);

        if (data.status === 'approved') {
          clearInterval(intervalRef.current);
          setTimeout(() => navigate(`/minhas-compras?payment_id=${paymentId}`), 1500);
        }
      } catch {
        // silencia erros de rede durante o polling
      }
    }, 5000);

    return () => clearInterval(intervalRef.current);
  }, [paymentId, navigate]);

  function copiarCodigo() {
    if (!pixCopyPaste) return;
    navigator.clipboard.writeText(pixCopyPaste).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  }

  if (!state) {
    return (
      <main className="page-container" style={{ textAlign: 'center', paddingTop: '48px' }}>
        <p>Nenhum pagamento ativo encontrado.</p>
        <Link to="/checkout" className="btn-primary" style={{ display: 'inline-block', marginTop: '16px' }}>
          Voltar ao checkout
        </Link>
      </main>
    );
  }

  return (
    <main className="page-container" style={{ maxWidth: '520px', margin: '0 auto', paddingTop: '32px' }}>
      <h2 style={{ textAlign: 'center' }}>Pague via PIX</h2>

      {status === 'approved' && (
        <div className="alert-success" style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '16px' }}>
          Pagamento confirmado! Redirecionando...
        </div>
      )}

      {status === 'pending' && (
        <div className="alert-info" style={{ textAlign: 'center', marginBottom: '16px' }}>
          Aguardando pagamento... Verificando automaticamente.
        </div>
      )}

      {status === 'rejected' && (
        <div className="alert-error" style={{ textAlign: 'center', marginBottom: '16px' }}>
          Pagamento recusado. <Link to="/checkout">Tente novamente.</Link>
        </div>
      )}

      <div className="card" style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {qrCode && (
          <img
            src={qrCode}
            alt="QR Code PIX"
            style={{ width: '220px', height: '220px', margin: '0 auto', borderRadius: '8px' }}
          />
        )}

        {ticketUrl && (
          <a href={ticketUrl} target="_blank" rel="noopener noreferrer" className="btn-secondary" style={{ color: 'white', textDecoration: 'none' }}>
            Abrir página do PIX
          </a>
        )}

        {pixCopyPaste && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <p style={{ fontSize: '0.85rem', color: '#64748b', margin: 0 }}>
              Ou copie o código abaixo e cole no seu banco:
            </p>
            <div style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              padding: '10px',
              wordBreak: 'break-all',
              fontSize: '0.78rem',
              color: '#475569',
              maxHeight: '80px',
              overflow: 'hidden',
            }}>
              {pixCopyPaste}
            </div>
            <button type="button" className="btn-primary" onClick={copiarCodigo}>
              {copied ? 'Copiado!' : 'Copiar código PIX'}
            </button>
          </div>
        )}

        <p style={{ fontSize: '0.85rem', color: '#94a3b8', margin: 0 }}>
          O QR Code expira em 30 minutos. Após o pagamento, a confirmação é automática.
        </p>
      </div>
    </main>
  );
}
